import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ImpactCard from "@/components/ImpactCard";
import CardExportActions from "@/components/CardExportActions";
import { BrandMark } from "@/components/Header";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function PublicImpact() {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/share/${publicId}`).then(({ data }) => setData(data)).catch(() => setErr(true));
  }, [publicId]);

  return (
    <div className="relative flex min-h-screen flex-col items-center px-5 py-10">
      <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(600px circle at 50% 0%, rgba(255,107,53,0.12), transparent 55%)" }} />
      <div className="relative z-10 w-full max-w-2xl">
        <div className="mb-10 flex justify-center"><BrandMark /></div>

        {err && <p className="text-center text-neutral-400">This impact card could not be found.</p>}

        {data && (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <ImpactCard data={data} />
            <div className="mx-auto mt-4 max-w-xs">
              <CardExportActions data={data} publicUrl={window.location.href} />
            </div>

            <div className="mt-10 flex flex-col items-center text-center">
              <h1 className="font-head text-3xl font-black tracking-tight text-white sm:text-4xl">What's blocking your business?</h1>
              <p className="mt-3 max-w-md text-neutral-400">Bring one blocker. Get one decisive next move. Take action. Leave.</p>
              <Button data-testid="public-cta-btn" onClick={() => navigate("/register")} className="btn-amber mt-6 rounded-full px-8 py-6 text-base">
                Get your next move <ArrowRight className="ml-1 h-5 w-5" />
              </Button>
              <p className="font-mono2 mt-6 text-xs uppercase tracking-wider text-neutral-600">One problem. One move. · MinuteSwap</p>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
